module.exports = __webpack_public_path__ + "static/Curbix-2-3f0b36724cbf6befd8d1fe277d616eef.jpg";